import '../css/BaselineText.scss'
import { sendData } from '../data/sendData'
import { divideText } from '../scripts/text'
import { dist, getTouchPosition, isEditTask } from '../scripts/utils'
import BaselineFloatingControls from './BaselineFloatingControls'
import BaselineTextarea from './BaselineTextarea'
import {
  _hub_exp_thisTask,
  _hub_restore_touchPoints,
  _hub_touchPoints,
} from './hub'
import NextButton from './tools/NextButton'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import isEqual from 'react-fast-compare'

export default class BaselineText extends Component {
  constructor(props) {
    super(props)

    this.state = {
      inSelecting: false,
      inRecognition: false,
      inRecognitionText: null,
    }

    this.onTouchstart = this._touchstartListener.bind(this)
    this.onSelectionchange = this._selectionchangeListener.bind(this)
    this.onStartRecognition = this.startRecognition.bind(this)
    this.onEndRecognition = this.endRecognition.bind(this)

    this.stopSelectionOut = null
  }

  componentDidMount() {
    window.getSelection().empty()
    document.addEventListener('touchstart', this.onTouchstart, {
      passive: false,
    })
    document.addEventListener('selectionchange', this.onSelectionchange)
  }

  componentWillUnmount() {
    window.getSelection().empty()
    document.removeEventListener('touchstart', this.onTouchstart)
    document.removeEventListener('selectionchange', this.onSelectionchange)
  }

  shouldComponentUpdate(prevProps, prevState) {
    return !isEqual(prevProps, this.props) || !isEqual(prevState, this.state)
  }

  startRecognition(tempText) {
    this.setState({
      inRecognition: true,
      inRecognitionText: tempText,
    })
  }

  endRecognition() {
    this.setState({
      inRecognition: false,
      inRecognitionText: null,
    })
  }

  /* -------------------------------------------------------------------------- */
  /*                                    Start                                   */
  /* -------------------------------------------------------------------------- */

  _touchstartListener(e) {
    const inText = inTextarea(e)

    if (inText) {
      this.setState(
        {
          inSelecting: true,
        },
        () => {
          _hub_touchPoints.start = _hub_touchPoints.now = getTouchPosition(e)
          this.props.attachTouchendFunction(this._touchendListener.bind(this))
          this.props.attachTouchmoveFunction(this._touchmoveListener.bind(this))
        }
      )
    } else {
      window.getSelection().empty()
    }

    sendData('touchstart', e, {
      touchSpeed: 0,
      touchTarget: inText ? 'text' : 'nonText',
      selectionArray: window.getSelection().toString(),
      textArray: _hub_exp_thisTask.text,
    })
  }

  /* -------------------------------------------------------------------------- */
  /*                                    Move                                    */
  /* -------------------------------------------------------------------------- */

  _touchmoveListener(e) {
    e.preventDefault()
    const t = _hub_touchPoints

    if (t.start) {
      t.now = getTouchPosition(e)
      if (!t.last) t.last = [...t.start]

      const {
        now: [nX, nY],
        last: [lX, lY],
      } = t

      t.thisStamp = performance.now()

      if (t.last) {
        const speed = dist(nX, nY, lX, lY) / (t.thisStamp - t.lastStamp)

        sendData('touchmove', e, {
          touchSpeed: speed,
          touchTarget: 'text',
          selectionArray: window.getSelection().toString(),
          textArray: _hub_exp_thisTask.text,
        })

        t.last = [...t.now]
        t.lastStamp = t.thisStamp
      }
    }

    return false
  }

  _selectionchangeListener(e) {
    if (this.stopSelectionOut) {
      clearTimeout(this.stopSelectionOut)
      this.stopSelectionOut = null
    }

    if (window.getSelection().toString())
      sendData('selectionchange', null, {
        touchSpeed: 0,
        touchTarget: 'text',
        selectionArray: window.getSelection().toString(),
        textArray: _hub_exp_thisTask.text,
      })

    this.stopSelectionOut = setTimeout(() => {
      _hub_restore_touchPoints()

      if (window.getSelection().toString())
        sendData('selectionend', null, {
          touchSpeed: 0,
          touchTarget: 'text',
          selectionArray: window.getSelection().toString(),
          textArray: _hub_exp_thisTask.text,
        })

      this.setState({
        inSelecting: false,
      })
    }, 1000)
  }

  /* -------------------------------------------------------------------------- */
  /*                                     End                                    */
  /* -------------------------------------------------------------------------- */

  _touchendListener(e) {
    e.preventDefault()
    _hub_restore_touchPoints()

    this.setState({
      inSelecting: false,
    })

    sendData('touchend', e, {
      touchSpeed: 0,
      touchTarget: 'text',
      selectionArray: window.getSelection().toString(),
      textArray: _hub_exp_thisTask.text,
    })
  }

  /* -------------------------------------------------------------------------- */

  render() {
    const { text } = this.props

    return (
      <>
        <BaselineTextarea
          text={text}
          targetText={_hub_exp_thisTask.targetText}
          editing={true}
          bodyChangeText={this.props.bodyChangeText}
        />
        {isEditTask(_hub_exp_thisTask.taskId) && (
          <BaselineFloatingControls
            text={text}
            selected={window.getSelection()}
            inSelecting={this.state.inSelecting}
            bodyChangeText={this.props.bodyChangeText}
            onStartRecognition={this.onStartRecognition}
            onEndRecognition={this.onEndRecognition}
          />
        )}
        {isEditTask(_hub_exp_thisTask.taskId) && (
          <NextButton selectedArray={divideText(window.getSelection())} />
        )}
      </>
    )
  }
}

BaselineText.propTypes = {
  text: PropTypes.string,
  instruction: PropTypes.string,
  attachTouchmoveFunction: PropTypes.func,
  attachTouchendFunction: PropTypes.func,
  bodyChangeText: PropTypes.func,
}

/* -------------------------------------------------------------------------- */

const inTextarea = e => {
  return e.target.id === 'baseline-text'
}
